import { render, staticRenderFns } from "./batchYYResult.vue?vue&type=template&id=6937f8a2&scoped=true"
import script from "./batchYYResult.vue?vue&type=script&lang=js"
export * from "./batchYYResult.vue?vue&type=script&lang=js"
import style0 from "./batchYYResult.vue?vue&type=style&index=0&id=6937f8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937f8a2",
  null
  
)

export default component.exports